module.exports = __webpack_public_path__ + "img/instagram.88340abe.png";